<hpo-content-layout [mobile]="mobile"
  [navigation]="false">

  <div class="content-container"
    [class.mobile]="mobile">

    @if (!initializing) {
      <h1 class="title">{{ 'default.file' | blah }}</h1>
      <div class="file-container">
        <p>{{fileName}}</p>
        <div class="button-container">
          <button mat-flat-button
            color="primary"
            [disabled]="loadingFile"
            (click)="downloadFile()">
            {{ 'default.downloadFile' | blah }}
          </button>
          @if (loadingFile) {
            <mat-progress-bar
            mode="indeterminate"></mat-progress-bar>
          }
        </div>
        <a mat-flat-button
          [routerLink]="'/' + alias">
          {{ 'default.backToInstruction' | blah }}
        </a>
      </div>
    }

    @if (initializing) {
      <hpo-placeholder type="row"></hpo-placeholder>
      <hpo-placeholder type="row"></hpo-placeholder>
      <hpo-placeholder type="row"></hpo-placeholder>
    }

    <app-copyright></app-copyright>

  </div>

</hpo-content-layout>